/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show wireframe</h4>

<p>Switch between wireframe and solid view of your model.</p>`;

export default function ShowWireframeTooltip() {
    return h('div', { innerHTML: body });
}
